R = require 'ramda'
React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
{ useObservable } = require 'utils/bacon'
md5 = require 'js-md5'

channelStore = require '../../stores/channel'

{ FormatMessage } = require 'react-globalize'

gravatarUrl = (email) ->
  email = email.toLowerCase().trim()
  emailHash = md5(email)
  "https://www.gravatar.com/avatar/#{emailHash}?s=72&d=mm"

Navbar = ({ user, children }) ->
  checkoutLogo = R.defaultTo "/assets/zuppler-logo.svg", useObservable channelStore.logo
  checkoutTitle = R.defaultTo "Zuppler", useObservable channelStore.name
  checkoutUrl = R.defaultTo "http://www.zuppler.com", useObservable channelStore.url

  <nav className="navbar navbar-inverse">
    <div className="container">
      <div className="navbar-header">
        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
          <span className="sr-only">
            <FormatMessage>checkout.navbar.toggle_navigation</FormatMessage>
          </span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
        <a className="navbar-brand" href={checkoutUrl} target="_blank">
          <img className="footer-logo" src={checkoutLogo} alt={checkoutTitle} title={checkoutTitle} height="42"/>
        </a>
      </div>

      <div id="navbar" className="navbar-collapse collapse">
        <ul className="nav navbar-nav navbar-right">
          { children }
          { viewUser( user ) }
        </ul>
      </div>
    </div>
  </nav>

viewUser = (user) ->
  return null unless user
  <li className="login-avatar">
    <a href="#">
      <span className="user-name">{user.name}</span>
      <div className="user-mask">
        <img src={ gravatarUrl(user.email) } title={user.email} alt={user.email} />
      </div>
    </a>
  </li>

module.exports = Navbar
